import React, { Fragment } from 'react';
import { Card, Col, Form, Input, Row, Select } from 'antd';

const { Option } = Select;
export default (props) => {

	const { getFieldDecorator } = props.form;

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Card title="Thông tin địa chỉ">
					<Row gutter={12}>
						<Col span={12}>
							<Form.Item label={'Địa chỉ'}>
								{getFieldDecorator('address1', {
								})(
									<Input disabled maxLength={255} placeholder={'Nhập địa chỉ'} allowClear />
								)}
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={'Địa chỉ 2'}>
								{getFieldDecorator('address2', {})(
									<Input disabled maxLength={255} placeholder={'Nhập địa chỉ 2'} allowClear/>
								)}
							</Form.Item>
						</Col>
						{/*<Col span={12}>*/}
						{/*	<Form.Item label={'Khu vực'}>*/}
						{/*		{getFieldDecorator('province', {})(*/}
						{/*			<Select disabled placeholder={'Chọn khu vực'} allowClear>*/}
						{/*				/!*<Option>Pending...</Option>*!/*/}
						{/*			</Select>*/}
						{/*		)}*/}
						{/*	</Form.Item>*/}
						{/*</Col>*/}
						{/*<Col span={12}>*/}
						{/*	<Form.Item label={'Xã phường'}>*/}
						{/*		{getFieldDecorator('ward', {})(*/}
						{/*			<Select disabled placeholder={'Chọn xã phường'} allowClear>*/}
						{/*				/!*<Option>Pending...</Option>*!/*/}
						{/*			</Select>*/}
						{/*		)}*/}
						{/*	</Form.Item>*/}
						{/*</Col>*/}
					</Row>
				</Card>
			</Form>
		</Fragment>
	);
};

